import { render, staticRenderFns } from "./detailAsessment.vue?vue&type=template&id=74b10be6&"
import script from "./detailAsessment.vue?vue&type=script&lang=js&"
export * from "./detailAsessment.vue?vue&type=script&lang=js&"
import style0 from "./detailAsessment.vue?vue&type=style&index=0&id=74b10be6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports